import { useReducer, useCallback, useContext } from "react";

import { TransformTypes } from "../../platform/backend/api-factory";
import AuthContext from "../../shared/context/auth-context";
import { IBackendType, IDeleteItemData, IDetailPageData,  IListPageData, IRegisterData, IUsers } from "../utils/api";
import { logger } from "../utils/logger";

interface IAction {
  type: string,
  errorMessage?: any, // eslint-disable-line
  responseData?: any // eslint-disable-line
}

interface IState {
  data?: IResponse | null,
  error: string | null,
  status: string | null,
}

export interface IResponse {
  [key: string]: any; // eslint-disable-line
}

function httpReducer(state: IState, action: IAction) {
  if (action.type === "SEND") {
    return {
      data: null,
      error: null,
      status: "pending",
    };
  }

  if (action.type === "SUCCESS") {
    return {
      data: action.responseData,
      error: null,
      status: "completed",
    };
  }

  if (action.type === "ERROR") {
    return {
      data: null,
      error: action.errorMessage,
      status: "completed",
    };
  }

  return state;
}
export type HTTPRequestFunction = (
  url: string,
  token: string,
  dataToBeSent?: IDetailPageData | IDeleteItemData | IRegisterData | string | IUsers | any, // eslint-disable-line
  type?: TransformTypes,
  backend?: IBackendType,
  tenant?: string,
  extraType?: string,
  successMsg?: string,
  errorMsg?: string
) => Promise<IDetailPageData | IListPageData |  IResponse | undefined>;

function useHttp(requestFunction: HTTPRequestFunction, startWithPending = false, token: string, type?: TransformTypes, backend: IBackendType = "platform") {
  const [httpState, dispatch] = useReducer(httpReducer, {
    status: startWithPending ? "pending" : null,
    data: null,
    error: null,
  });

  const authCtx = useContext(AuthContext);

  const sendRequest = useCallback(
    async function (url: string, dataToBeSent?: IDetailPageData | IDeleteItemData | IRegisterData | string | IUsers | any, extraType?: string, successMsg?: string, errorMsg?: string) { // eslint-disable-line
      dispatch({ type: "SEND" });
      try {
        const responseData = await requestFunction(url, token, dataToBeSent, type, backend, authCtx.selectedTenant.selected_tenant_id, extraType, successMsg, errorMsg);
        dispatch({ type: "SUCCESS", responseData });
      } catch (error) {
        const errorMessage = (error instanceof Error) ? error.message : "Something went wrong!";
        logger.error(errorMessage);
        dispatch({
          type: "ERROR",
          errorMessage: errorMessage,
        });
      }
    },
    [requestFunction, token, type]
  );

  return {
    sendRequest,
    ...httpState,
  };
}
export default useHttp;
